export default {"src":"/_next/static/media/24_hours.cfb60f7f.svg","height":100,"width":150};